var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPepsicoSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15463_313724",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15463_313724)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8457 41.5239C52.4923 27.2734 40.8301 11.2253 24.9312 9.24161L24.9584 9.04688C40.6322 9.04688 52.648 24.3375 52.648 36.4004C52.6329 38.9116 52.4447 40.4674 52.1091 41.597L51.8457 41.5239ZM50.896 43.3353C49.8532 44.678 48.5417 46.0299 47.0051 47.3134C44.1783 30.1811 32.2314 15.2002 23.7851 10.8276L23.6041 10.9605C32.0985 18.3068 42.2299 32.5747 46.1699 47.9855C44.1602 49.5411 41.9893 50.8512 39.699 51.8904C31.6834 42.2579 24.2104 23.6807 21.8022 11.8923L21.5573 11.97C21.6116 23.4129 29.3212 42.8385 38.7231 52.3172C36.5668 53.2164 34.325 53.8691 32.0365 54.2641C23.024 50.5017 16.609 38.4516 16.609 26.1075C16.609 18.0492 18.9405 13.0643 19.3916 12.0441L19.1996 11.9638C18.6539 12.8338 15.2383 17.8161 15.2383 26.5159C15.2383 40.469 21.7683 51.134 30.4378 54.4925C27.3376 54.8519 24.2031 54.6968 21.1484 54.033L21.0839 54.2457C22.0113 54.6055 25.1577 55.9973 29.9576 55.9973C40.8141 55.9973 48.1532 48.8891 51.1075 43.4861L50.896 43.3353Z",
    fill: "#06549C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.892 4C20.662 4 11.0117 10.2592 11.0117 15.9807C11.0117 18.1938 12.9329 20.0635 16.9093 20.0635C26.1399 20.0635 34.7158 13.3806 34.7158 8.18403C34.7158 5.44954 32.2237 4 28.892 4ZM32.1777 8.02251C32.1777 12.4028 24.1954 17.7573 17.5228 17.7573C14.5748 17.7573 12.9819 16.5347 12.9819 14.5173C12.9819 10.0742 21.0548 4.81064 27.3137 4.81064C31.3943 4.81064 32.1777 6.99874 32.1777 8.02251Z",
    fill: "#1A99D5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66559 18.6469C7.43423 19.0686 6.50781 20.9802 6.50781 22.9389C6.50781 26.5714 9.99084 29.9438 16.3972 29.9438C28.7214 29.9438 42.9601 20.3843 42.9601 11.5106C42.9601 7.52744 39.382 5.36181 36.8976 4.91406L36.8511 5.06944C37.6237 5.32705 40.4544 6.71373 40.4544 10.262C40.4544 17.3323 27.8828 26.966 15.3602 26.966C10.5661 26.966 7.54579 24.4722 7.54579 20.8397C7.54579 19.6907 7.77278 18.9337 7.83293 18.7144L7.66559 18.6469Z",
    fill: "#F47A3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1086 12.1641C48.4466 12.4344 50.4765 14.2172 50.4765 17.5886C50.4765 29.0836 33.3849 40.3871 18.2746 40.3871C9.26367 40.3871 5.15592 35.6986 5.33781 31.5355H5.49933C5.85243 33.6975 8.77815 37.5662 16.6648 37.5662C31.794 37.5662 48.6862 25.8702 48.6862 15.6228C48.6862 13.8651 48.2332 12.7697 47.9771 12.2826L48.1086 12.1641Z",
    fill: "#16A751"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7828 22.875C53.8536 23.1198 54.2218 24.2203 54.2218 25.9438C54.2218 38.7309 36.925 49.6781 21.8817 49.6781C14.1391 49.6781 10.0958 45.7148 9.24219 44.1053L9.37994 43.998C11.5223 45.9724 15.7421 47.4726 20.6667 47.4726C33.9527 47.4726 53.7775 36.8209 53.6004 22.9215L53.7828 22.875Z",
    fill: "#EC2028"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepsicoSymbol);
export default __webpack_public_path__ + "static/media/Pepsico_Symbol.fb1e2dfed25db8f7d97928aafbfae021.svg";
export { ForwardRef as ReactComponent };